/* eslint-disable */
import Immutable, { Map } from 'immutable';
import { combineReducers as immutableCombineReducers } from 'redux-immutable';

let combineReducers = immutableCombineReducers;

// фикс для Redux DevTools (при импорте выдает mutable коллекцию)
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {

  function validateNextState(nextState, reducerName, action) {
    if (nextState === undefined) {
      throw new Error('Reducer "'
        + reducerName
        + '" returned undefined when handling "'
        + action.type
        + '" action. To ignore an action, you must explicitly return the previous state.');
    }
    return null;
  }

  combineReducers = function combineReducers(reducers) {

    var reducerKeys = Object.keys(reducers);

    return function () {

      var inputState = arguments.length <= 0 || arguments[0] === undefined ? Map() : arguments[0];

      var action = arguments[1];

      if (!Immutable.Iterable.isIterable(inputState)) {
        inputState = Immutable.fromJS(inputState);
      }

      return inputState.withMutations(function (temporaryState) {
        reducerKeys.forEach(function (reducerName) {
          var reducer = reducers[reducerName];
          var currentDomainState = temporaryState.get(reducerName);
          var nextDomainState = reducer(currentDomainState, action);

          (0, validateNextState)(nextDomainState, reducerName, action);

          temporaryState.set(reducerName, nextDomainState);
        });
      });

    };
  };
}

export default combineReducers;
